import { Box } from '@mui/joy';
import { isString } from 'lodash';

export const renderHtmlMessage = (message: string | JSX.Element) => {
  if (isString(message)) {
    return parseMessageContent(message);
  }

  return message;
};

export const parseMessageContent = (content: string) => {
  const parts = content.split(/(<br\s*\/?>|\n|<strong>.*?<\/strong>)/);

  return (
    <Box>
      {parts.map((part, index) => {
        if (part.match(/<br\s*\/?>/i) || part === '\n') {
          return <br key={index} />;
        }

        if (part.match(/<strong>(.*?)<\/strong>/)) {
          const strongContent = part.match(/<strong>(.*?)<\/strong>/)[1];

          return <strong key={index}>{strongContent}</strong>;
        }

        return part;
      })}
    </Box>
  );
};
